var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lay-container"},[_c('div',{staticClass:"lay-head"},[_c('LayHead')],1),_c('div',{staticClass:"lay-main clearfix"},[_c('div',{staticClass:"lay-left"},[_c('LayLeft')],1),_c('div',{staticClass:"lay-right"},[_c('LayMenu'),_c('div',{staticClass:"lay-content"},[_vm._t("default")],2)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }